import styled from 'styled-components/macro';

// utils
import mq from '../../../utils/mediaQueriesBp';
import { NavLink } from 'react-router-dom';

// interface IProps {
//   className: string;
// }

const ATCButtonLinkWrapper = styled.div`
  transition: all 0.3s;
`;

const ATCButtonLink = styled(NavLink)`
  position: relative;
  overflow: hidden;
  text-decoration: none;
  display: inline-flex;
  justify-content: flex-end;
  align-items: center;
  border-radius: 5px;
  width: 100%;
  height: 28px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;

  &:before {
    content: '';
    display: inline-flex;
    position: absolute;
    right: -10px;
    width: 100%;
    height: 100%;
    transform: skewX(10deg);
    background: rgba(41, 41, 58, 0.24);
    border-radius: 5px;
    z-index: 0;
    transition: all 0.3s;
  }

  span {
    display: inline-flex;
    padding: 4px 8px 4px 5px;
    color: ${props => props.theme.colors.white};
    z-index: 1;
  }

  svg {
    z-index: 1;
  }
`;

export { ATCButtonLinkWrapper, ATCButtonLink };
